import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import { useContext, useEffect } from 'react';

import FormSelectMultiple from '@form/FormSelectMultiple';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@ui';
import InfoTooltip from '@ui/InfoTooltip';
import { FieldValues, FormProvider, useForm } from 'react-hook-form';
import FilterContext from '../Filter/FilterContext';
import { SelectFilter as SelectFilterInterface } from './types';

interface Props extends Partial<Omit<SelectFilterInterface, 'filterType'>> {
    filterKey: string;
    callback?: () => void;
    size?: 'xs' | 'md';
    // Volle Spaltenbreite statt fixer 400px (Formular-Kontext)
    fullWidth?: boolean;
}

export const SelectMultipleFilter = ({
    filterName,
    filterTooltip,
    filterKey,
    callback,
    size = 'xs',
    fullWidth = false,
    options
}: Props) => {
    const [filter, setFilter] = useContext(FilterContext);
    const methods = useForm({ defaultValues: { [filterKey]: filter?.[filterKey] } });
    const { handleSubmit, reset } = methods;

    useEffect(() => {
        reset({ [filterKey]: filter?.[filterKey] });
    }, [filter, filterKey, reset]);

    const handleSubmitFilter = (data: FieldValues) => {
        setFilter({ ...filter, ...data });
        callback?.();
    };

    const resetFilter = () => {
        setFilter({ ...filter, [filterKey]: undefined });
        callback?.();
    };

    return (
        <form onSubmit={handleSubmit(handleSubmitFilter)}>
            <FormProvider {...methods}>
                <div
                    className="tw-flex tw-items-baseline tw-gap-6 tw-px-2"
                    style={{ minWidth: fullWidth || size !== 'xs' ? '100%' : 400 }}
                >
                    {filterName && (
                        <b className="tw-m-0 tw-flex tw-w-[30%] tw-shrink-0 tw-items-center tw-gap-1 tw-truncate tw-text-sm">
                            <span className="tw-truncate">{filterName}</span>
                            {filterTooltip && <InfoTooltip tooltip={filterTooltip} />}
                        </b>
                    )}
                    <FormSelectMultiple
                        buttonProps={{ size: 'xs' }}
                        className="!tw-my-0 tw-max-w-full tw-flex-1 tw-overflow-hidden"
                        name={`${filterKey}.value`}
                        options={
                            options?.map((option) => ({
                                key: option.value,
                                label: option.label
                            })) ?? []
                        }
                    />
                    <div className="tw-flex tw-gap-2">
                        <Button type="button" color="error" auto size={size} onPress={resetFilter}>
                            <FontAwesomeIcon icon={faTimes} />
                        </Button>
                        <Button type="submit" color={filter?.[filterKey] ? 'warning' : 'success'} auto size={size}>
                            <FontAwesomeIcon icon={faCheck} />
                        </Button>
                    </div>
                </div>
            </FormProvider>
        </form>
    );
};
